import { Flex, SVGButton, SelectInput, TextInput } from "/app/src/component";
import _ from "underscore";
import style from "./style.css";
import React from "react";
const OnlineFormsContainerStyle = {
  dataName: "OnlineFormsContainer",
  hAlignContent: "center",
  column: true,
  width: "100%",
  shrink: 0,
  color: "black",
};
const FormularsContainerBodyStyle = {
  dataName: "FormularContainerBody",
  w: "100%",
  fontSize: "24px",
  color: "lightblack",
  fontWeight: "300",
  hAlignContent: "center",
  column: true,
};

const SmallContainerStyle = {
  maxWidth: "456px",
  width: "100%",
  grow: 1,
};
export default ({ formsConfig, setFormsConfig }) => {
  const configClick = (name, type) => {
    formsConfig[name][type] = !formsConfig[name][type];
    setFormsConfig(formsConfig);
  };

  const renderForm = (placeholder, name, aliases) => {
    let visible = formsConfig[name]["visible"];
    const VisibleButtonProps = {
      src: visible ? "/images/Visible.svg" : "/images/Hidden.svg",
      color: visible ? "blue" : "lightgrey",
      width: "50px",
      onClick: () => configClick(name, "visible"),
    };
    let required = formsConfig[name]["require"];
    const RequiredButtonProps = {
      src: required ? "/images/Require_Confirmed.svg" : "/images/Require.svg",
      color: required ? (visible ? "blue" : "lightgrey") : "lightgrey",
      width: "50px",
      onClick: () => configClick(name, "require"),
    };

    let Field = null;
    const inputClass = visible
      ? style.UnselectableTextVisible
      : style.UnselectableText;
    if (!_.isEmpty(aliases)) {
      const inputClass = visible
        ? style.UnselectableTextVisible
        : style.UnselectableText;
      Field = (
        <SelectInput
          values={aliases}
          select={formsConfig[name].alias}
          onChange={(e) => {
            formsConfig[name].alias = e.target.value;
            setFormsConfig(formsConfig);
          }}
          width="70%"
          name="visitor"
          className={inputClass}
        />
      );
    } else {
      Field = (
        <TextInput
          className={inputClass}
          placeholder={placeholder}
          disabled
          w="70% !important"
        />
      );
    }

    return (
      <Flex width="100%" userSelect="none">
        {Field}
        <SVGButton {...VisibleButtonProps} />
        <SVGButton {...RequiredButtonProps} />
      </Flex>
    );
  };
  return (
    <Flex {...OnlineFormsContainerStyle}>
      <Flex {...FormularsContainerBodyStyle}>
        <Flex {...SmallContainerStyle} fontSize="14px">
          <Flex w="70%" shrink={0}></Flex>
          <Flex basis="50px" center>
            Visa
          </Flex>
          <Flex basis="50px" center>
            Kräv
          </Flex>
        </Flex>
        <Flex {...SmallContainerStyle}>
          {renderForm("E-mail", "email", [])}
        </Flex>
        <Flex {...SmallContainerStyle}>{renderForm("Namn", "name", [])}</Flex>
        <Flex {...SmallContainerStyle}>
          {renderForm("Telefonnummer", "phone", [])}
        </Flex>
        <Flex {...SmallContainerStyle}>
          {renderForm("Referensnummer", "customer_ref", {
            ref: "Referensnummer",
            ord: "Ordernummer",
            cust: "Kundnummer",
          })}
        </Flex>
      </Flex>
    </Flex>
  );
};



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/Formular/_OnlineFormular.js